var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#669D24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8C9.33579 8 9 8.33579 9 8.75C9 9.16421 9.33579 9.5 9.75 9.5H18.25C18.6642 9.5 19 9.16421 19 8.75C19 8.33579 18.6642 8 18.25 8H9.75ZM14.5303 10.7197C14.2374 10.4268 13.7626 10.4268 13.4697 10.7197L10.2197 13.9697C9.92678 14.2626 9.92678 14.7374 10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L13.25 13.0607V19.25C13.25 19.6642 13.5858 20 14 20C14.4142 20 14.75 19.6642 14.75 19.25V13.0607L16.7197 15.0303C17.0126 15.3232 17.4874 15.3232 17.7803 15.0303C18.0732 14.7374 18.0732 14.2626 17.7803 13.9697L14.5303 10.7197Z",
    fill: "#669D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.431bf1c34f100d6574ddf2074f60d60d.svg";
export { ForwardRef as ReactComponent };